import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_prime-detail-service/artifacts/2no31ay6_Prime%20Detailing%20mascot%20logo.png" 
                alt="Prime Detail Logo" 
                className="h-20 w-auto"
              />
            </div>
            <p className="text-gray-400 mb-4">
              Premium mobile auto detailing service. We bring professional care to your doorstep.
            </p>
            <div className="flex items-center text-green-400">
              <MapPin className="h-5 w-5 mr-2" />
              <span className="text-sm">40-mile mobile service radius</span>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Information</h4>
            <div className="space-y-3">
              <a 
                href={`tel:${businessInfo.phone}`}
                className="flex items-center text-gray-400 hover:text-green-400 transition-colors"
              >
                <Phone className="h-5 w-5 mr-3" />
                {businessInfo.phone}
              </a>
              <a 
                href={`mailto:${businessInfo.email}`}
                className="flex items-center text-gray-400 hover:text-green-400 transition-colors break-all"
              >
                <Mail className="h-5 w-5 mr-3 flex-shrink-0" />
                {businessInfo.email}
              </a>
              <div className="flex items-center text-gray-400">
                <MapPin className="h-5 w-5 mr-3 flex-shrink-0" />
                <span>{businessInfo.location}</span>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Business Hours</h4>
            <div className="flex items-start text-gray-400">
              <Clock className="h-5 w-5 mr-3 mt-1 flex-shrink-0" />
              <div>
                <p className="font-medium text-white">{businessInfo.days}</p>
                <p>{businessInfo.hours}</p>
                <p className="mt-2 text-sm">Closed Sunday</p>
              </div>
            </div>
            <div className="mt-6 p-4 bg-green-600/10 border border-green-600/30 rounded-lg">
              <p className="text-sm text-green-400 font-semibold">
                {businessInfo.discount.amount} OFF for {businessInfo.discount.eligible}
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} Prime Detail. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs mt-2">
            Professional Mobile Auto Detailing • Newmanstown, PA
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
